import { render, staticRenderFns } from "./selectStaff.vue?vue&type=template&id=6b0c8da6&scoped=true"
import script from "./selectStaff.vue?vue&type=script&lang=js"
export * from "./selectStaff.vue?vue&type=script&lang=js"
import style0 from "./selectStaff.vue?vue&type=style&index=0&id=6b0c8da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c8da6",
  null
  
)

export default component.exports